// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2165":"0becbacc772e6bc9","7831":"1619e3a0920bd852","7938":"894e1925fc5ee401","8259":"8e771c9dab1d9356","8552":"8487ce50197aa198"}[chunkId] + ".js";
};